import React from 'react';
import { format } from 'date-fns';
import { X } from 'lucide-react';
import { useCerrarConEscape } from '../../hooks/useCerrarConEscape';

/** Piezas de interfaz comunes a los modales de A medias. */

export const claseInput =
  'w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 ' +
  'text-gray-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent';

export const Campo: React.FC<{ label: string; children: React.ReactNode; ayuda?: string }> =
  ({ label, children, ayuda }) => (
    <div className="flex flex-col gap-1 min-w-0">
      <label className="text-xs font-semibold text-gray-600 dark:text-gray-400">{label}</label>
      {children}
      {ayuda && <p className="text-[11px] text-gray-500 dark:text-gray-500">{ayuda}</p>}
    </div>
  );

export const aInput = (d?: Date) => (d ? format(d, 'yyyy-MM-dd') : '');
// Mediodía local, para que el cambio de huso no la mueva de día
export const deInput = (s: string) => (s ? new Date(`${s}T12:00:00`) : undefined);

/** Acepta coma o punto decimal, como se escribe en el móvil. */
export const leerImporte = (s: string) => {
  const n = parseFloat(s.replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};

export const MensajeError: React.FC<{ texto: string }> = ({ texto }) =>
  texto ? (
    <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800
                    text-red-700 dark:text-red-300 rounded-lg px-3 py-2 text-sm">
      {texto}
    </div>
  ) : null;

export const ModalBase: React.FC<{ titulo: string; onClose: () => void; children: React.ReactNode }> =
  ({ titulo, onClose, children }) => {
  useCerrarConEscape(onClose);
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center capa-hoja"
      onClick={onClose}>
      <div onClick={e => e.stopPropagation()}
        className="hoja bg-white dark:bg-gray-800 w-full sm:max-w-lg sm:rounded-2xl rounded-t-2xl
                   max-h-full overflow-y-auto shadow-2xl">
        <div className="sticky top-0 z-10 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700
                        px-5 py-4 flex items-center justify-between">
          <h2 className="text-lg font-bold text-gray-900 dark:text-white">{titulo}</h2>
          <button type="button" onClick={onClose} aria-label="Cerrar"
            className="boton-cerrar text-gray-400 hover:text-gray-700 dark:hover:text-gray-200
                       hover:bg-gray-100 dark:hover:bg-gray-700 transition">
            <X className="w-5 h-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const BotonesModal: React.FC<{ guardando: boolean; texto: string; onClose: () => void }> =
  ({ guardando, texto, onClose }) => (
    <div className="flex gap-2 pt-2">
      <button type="submit" disabled={guardando}
        className="flex-1 py-2.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white
                   text-sm font-semibold transition disabled:opacity-60">
        {guardando ? 'Guardando…' : texto}
      </button>
      <button type="button" onClick={onClose}
        className="px-5 py-2.5 rounded-lg border border-gray-300 dark:border-gray-600
                   text-gray-700 dark:text-gray-300 text-sm font-semibold
                   hover:bg-gray-50 dark:hover:bg-gray-700 transition">
        Cancelar
      </button>
    </div>
  );

/** Botón de selección tipo «pastilla», con el acento del módulo. */
export const chip = (activo: boolean) =>
  `px-3 py-1.5 text-xs font-semibold rounded-lg border transition ${
    activo
      ? 'bg-emerald-600 border-emerald-600 text-white'
      : 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:border-gray-400'
  }`;
